import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'


const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "flex items-center gap-2 text-xs text-gray-400" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "ml-1",
  src: _imports_0,
  alt: "wa-icon"
}, null, -1)
const _hoisted_4 = {
  class: "font-normal",
  "data-testid": "pickup-dashboard-row-total-shipment"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TableSummary = _resolveComponent("TableSummary")!
  const _component_ManualAssignModal = _resolveComponent("ManualAssignModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_TableSummary, {
      columns: _ctx.columns,
      tableData: _ctx.detailSummary,
      sortKey: _ctx.sortKey,
      sortOrder: _ctx.sortOrder,
      enableSort: true,
      pagination: _ctx.pagination,
      startIndex: _ctx.startIndex,
      isLoading: _ctx.isLoading,
      onSort: _ctx.handleSort,
      onSetPage: _ctx.onPageChange,
      onSelectAll: _ctx.handleSelectAll,
      onSelectRow: _ctx.onSelectRow
    }, {
      "cell-senderName": _withCtx(({ item }) => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", {
            title: item.senderName,
            class: "font-medium text-gray-900 two-line",
            style: {"width":"200px"}
          }, _toDisplayString(item.senderName), 9, ["title"]),
          _createVNode("a", {
            target: "_blank",
            href: `https://wa.me/${_ctx.waNumber(item.senderPhone)}`
          }, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(_ctx.formatPhoneNumber(item.senderPhone)), 1),
              _hoisted_3
            ])
          ], 8, ["href"])
        ])
      ]),
      "cell-totalShipment": _withCtx(({ item }) => [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.fmtQty(item.totalShipment)) + " (" + _toDisplayString(_ctx.fmtQty(item.totalQuantity)) + ")", 1)
      ]),
      "cell-senderAddress": _withCtx(({ item }) => [
        _createVNode("a", {
          href: `${_ctx.mapsHref(item)}`,
          target: "_blank",
          class: "text-red-lp-100 underline line-clamp-2"
        }, _toDisplayString(item.senderAddress), 9, ["href"])
      ]),
      "cell-action": _withCtx(({ item }) => [
        _createVNode("button", {
          onClick: ($event: any) => (_ctx.openAssignModal(item)),
          class: "p-2 hover:bg-gray-100 rounded-lg transition-colors"
        }, [
          _createVNode(_component_Icons, { name: "transfer-pickup" })
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "tableData", "sortKey", "sortOrder", "pagination", "startIndex", "isLoading", "onSort", "onSetPage", "onSelectAll", "onSelectRow"]),
    _createVNode(_component_ManualAssignModal, {
      show: _ctx.showAssignModal,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAssignModal = $event)),
      selectedSellers: _ctx.selectedSellersForAssign,
      onAssignSuccess: _ctx.handleAssignSuccess
    }, null, 8, ["show", "selectedSellers", "onAssignSuccess"])
  ], 64))
}